import { render } from "./Mb065.vue?vue&type=template&id=527d93c2&scoped=true"
import script from "./Mb065.vue?vue&type=script&lang=js"
export * from "./Mb065.vue?vue&type=script&lang=js"

import "./Mb065.vue?vue&type=style&index=0&id=527d93c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527d93c2"]])

export default __exports__